import React, { useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import axios from 'axios';
import './Notas.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Notas = ({ selectedDate, notasActualizadas, setNotasActualizadas }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [notasDelDia, setNotasDelDia] = useState([]);

  useEffect(() => {
    const fetchNotas = async () => {
      if (!selectedDate) return;

      try {
        console.log("Fecha enviada a la API:", selectedDate);
        const response = await axios.get(`${apiUrl}/api/todasnotas/${selectedDate}`);

        console.log("Datos recibidos:", response.data);
        setNotasActualizadas(false);
        setNotasDelDia(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching notas:", error);
        setNotasDelDia([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotas();
  }, [selectedDate, notasActualizadas]);

  // ✅ Función para eliminar nota
  const handleEliminarNota = async (id_nota) => {
    if (!window.confirm('¿Seguro que quieres eliminar esta nota?')) return;

    try {
      await axios.delete(`${apiUrl}/api/eliminarnota/${id_nota}`);
      setNotasDelDia((prev) => prev.filter((nota) => nota.id_nota !== id_nota));
    } catch (error) {
      console.error("Error al eliminar nota:", error);
      alert("No se pudo eliminar la nota. Intenta nuevamente.");
    }
  };

  return (
    <Container fluid className="notes-container px-0">
      <Card className="notes-card">
        <Card.Body className="notes-card-body">
          <Card.Title className="notes-title">
            <i className="bi bi-journal-text me-2"></i>
            Notas del día
            <span className="notes-count">{notasDelDia?.length || 0}</span>
          </Card.Title>

          {loading ? (
            <div className="text-center py-3">
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : notasDelDia?.length === 0 ? (
            <div className="no-notes text-center py-3">
              <i className="bi bi-info-circle fs-4"></i>
              <p className="mt-2 mb-0">No hay notas para este día</p>
            </div>
          ) : (
            <div className={`notes-wrapper ${notasDelDia.length > 3 ? 'with-scroll' : ''}`}>
              <div className="notes-grid">
                {notasDelDia.map((nota) => (
                  <div key={nota.id_nota} className="note-bubble">
                    <button
                      className="btn-delete-note"
                      onClick={() => handleEliminarNota(nota.id_nota)}
                      title="Eliminar nota"
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                    <p className="note-text">{nota.observacion}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Notas;
